<template>
  <div class="gift-get-popup">
    <img :src="pageInfo.img.normalPopup" />
    <a class="close" href="javascript:;" @click="closePopup"></a>
    <div class="content">
      <p class="title" :style="mainColor">恭喜獲得禮包兌換碼</p>
      <p class="text pretitle" :style="fontcolor">收藏頁面到瀏覽器，方便下次再玩喔～</p>
      <p class="number" :style="numberColor">{{giftNumberGetPopupState}}</p>
      <p class="tips" :style="mainColor">兌換說明:</p>
      <p class="text" :style="fontcolor">1、{{pageInfo.gift.exchangeTips}}</p>
      <p class="text" :style="fontcolor">2、一個帳號只能兌換一次下載禮包</p>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapActions } from "vuex";
export default {
  computed: {
    fontcolor() {
      return `color:${this.pageInfo.color.font}`;
    },
    mainColor() {
      return `color:${this.pageInfo.color.main}`;
    },
    numberColor() {
      return `color:${this.pageInfo.color.font};background-color:${this.pageInfo.color.tableBg}`;
    },
    ...mapGetters(["giftNumberGetPopupState", "pageInfo"]),
  },
  methods: {
    closePopup() {
      this.$store.commit("updateState", {
        action: "giftNumberGetPopupState",
        value: "",
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.gift-get-popup {
  position: absolute;
  width: 578px;
  height: 362px;
  top: 50%;
  left: 50%;
  margin-left: -289px;
  margin-top: -181px;
  z-index: 20;
  box-sizing: border-box;
  img {
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -1;
    top: 0;
    left: 0;
  }
  .close {
    position: absolute;
    z-index: 2;
    width: 50px;
    height: 50px;
    top: 0;
    right: 0;
    cursor: pointer;
  }
  .content {
    position: absolute;
    width: 100%;
    top: 0;
    text-align: center;
    font-size: 20px;
    .title {
      font-size: 28px;
      font-weight: 600;
      margin: 40px auto 4px;
    }
    .text,
    .tips {
      font-size: 18px;
      margin: 0 30px;
      line-height: 180%;
      text-align: left;
    }
    .tips {
      font-weight: 600;
      font-size: 20px;
    }
    .pretitle {
      text-align: center;
    }
    .number {
      margin: 25px 30px;
      padding: 20px 0;
      font-weight: 600;
      font-size: 22px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/GiftGetPopup.vue